export default function formatCurrency(currencyInWholeCents: number, alwaysFormatInDollars = false) {
	if (alwaysFormatInDollars || currencyInWholeCents >= 100) {
		const currencyInDollars = (currencyInWholeCents / 100).toFixed(2);
		return `$${currencyInDollars}`;
	}
	return `${currencyInWholeCents}¢`;
}
